// Shared character-class rules for form fields, so every form enforces
// the same "proper" input for a given field type instead of free text.

// Names, cities, states: letters, spaces, apostrophes and hyphens only
// (covers names like "O'Brien" or "Saint-Denis").
export const ALPHA_REGEX = /^[A-Za-z\s'-]+$/;

export const stripNonAlpha = (value: string): string =>
    value.replace(/[^A-Za-z\s'-]/g, '');

// Postal/ZIP codes: letters, digits, spaces and hyphens (covers US "12345"
// and formats like Canada's "K1A 0B1" or UK's "SW1A 1AA").
export const ZIP_REGEX = /^[A-Za-z0-9\s-]+$/;

export const stripNonZip = (value: string): string =>
    value.replace(/[^A-Za-z0-9\s-]/g, '');

// Phone numbers: digits only, no letters or symbols.
export const PHONE_REGEX = /^[0-9]{7,15}$/;

export const stripNonNumeric = (value: string): string =>
    value.replace(/[^0-9]/g, '');
